import { render, staticRenderFns } from "./IncomesMonthly.vue?vue&type=template&id=3352f74d&"
import script from "./IncomesMonthly.vue?vue&type=script&lang=js&"
export * from "./IncomesMonthly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports